import { defineNuxtPlugin, useHead, useRoute } from '#app';

import { useBuildUrl } from '@/composables/utils/useBuildUrl';

export default defineNuxtPlugin(() => {
  const route = useRoute();
  const { buildUrlWithEndSlash } = useBuildUrl();

  useHead({
    link: () => (route.meta.lp ? [{ rel: 'canonical', href: buildUrlWithEndSlash(route.path) }] : []),
  });
});
